import React from "react";
import "./footer.css";
import { Link } from "react-router-dom";

import {
  FaFacebookF,
  FaYoutube,
  FaInstagram,
  FaLinkedinIn,
  FaArrowUp,
} from "react-icons/fa";

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  /* ── Nav columns ────────────────────────────────── */
  const cols = [
    {
      heading: "Company",
      links: [
        { label: "About Suvidha", to: "/" },
        { label: "Our Services", to: "/services" },
        { label: "Plans & Pricing", to: "/plans" },
        { label: "Blogs", to: "/blogs" },
        { label: "Contact Us", to: "/Contact" },
      ],
    },

    {
      heading: "For Users",
      links: [
        { label: "Book a Service", to: "/book-service" },
        { label: "My Bookings", to: "/my-bookings" },
        { label: "My Subscription", to: "/my-subscription" },
        { label: "My Account", to: "/survey/care_needs/done" },
      ],
    },

    {
      heading: "Terms & Policies",
      links: [
        {
          label: "Terms & Conditions",
          to: "/terms",
          hash: "terms",
        },
        {
          label: "Refund Policy",
          to: "/terms",
          hash: "refund",
        },
        {
          label: "Privacy Policy",
          to: "/terms",
          hash: "privacy",
        },
        {
          label: "Cookies Policy",
          to: "/terms",
          hash: "cookies",
        },
        {
          label: "Disclaimer",
          to: "/terms",
          hash: "disclaimer",
        },
      ],
    },
  ];

  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Dynamic nav columns */}
        {cols.map((col) => (
          <div key={col.heading} className="footer-col">
            <h3>{col.heading}</h3>

            <ul>
              {col.links.map((link) => (
                <li key={link.label}>
                  <Link
                    to={
                      link.hash
                        ? `${link.to}?tab=${link.hash}`
                        : link.to
                    }
                    style={{
                      color: "inherit",
                      textDecoration: "none",
                    }}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}

        {/* Get the App */}
        <div className="footer-col">
          <h3>Get the App</h3>

          <img
            src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
            alt="Google Play"
            className="store-btn"
          />

          <img
            src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
            alt="App Store"
            className="store-btn"
          />

          <p
            style={{
              marginTop: 16,
              fontSize: 13,
              color: "var(--base-neutral)",
              lineHeight: 1.7,
            }}
          >
            Download the Suvidha app for real-time health updates,
            emergency alerts and easy booking.
          </p>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} Suvidha Elder Care.
          All rights reserved.
        </p>

        <p>
          Feedback:{" "}
          <span className="email">
            <a href="mailto:support@suvidhacare.in">
              support@suvidhacare.in
            </a>
          </span>
        </p>

        <div className="social-icons">
          <a
            href="#"
            aria-label="Facebook"
            style={{ color: "inherit" }}
          >
            <FaFacebookF />
          </a>

          <a
            href="#"
            aria-label="YouTube"
            style={{ color: "inherit" }}
          >
            <FaYoutube />
          </a>

          <a
            href="#"
            aria-label="Instagram"
            style={{ color: "inherit" }}
          >
            <FaInstagram />
          </a>

          <a
            href="#"
            aria-label="LinkedIn"
            style={{ color: "inherit" }}
          >
            <FaLinkedinIn />
          </a>
        </div>
      </div>

      {/* Scroll to top */}
      <button
        type="button"
        className="scroll-top"
        onClick={scrollToTop}
        title="Back to top"
        aria-label="Back to top"
      >
        <FaArrowUp />
      </button>
    </footer>
  );
}

// ### What was fixed

// * Removed unused `useState` and `useEffect`.
// * Removed unused `useNavigate`.
// * Removed unused contact-form code that was commented out.
// * Removed unused contact icons.
// * Added a proper `scrollToTop()` function.
// * Changed the scroll-top `<div>` to a proper `<button>`.
// * Kept all your existing footer links and policy links.
// * Kept Google Play and App Store badges.
// * Kept your social icons and email.
// * Kept the dynamic copyright year.

// Your original footer navigation structure is preserved, including the `?tab=terms`, `?tab=refund`, etc. behavior.

// If you actually want the **Contact Us form to appear inside this Footer component**, rather than just cleaning the footer, then the form needs to be uncommented and its state/API code restored.
